import { jsx as _jsx } from "react/jsx-runtime";
import { getViewDefinitionForNewObject } from '../../../v2/components/ExceptionTypesHandling/viewDefinitions';
import { UserDetailCard } from '../../../v2/components/generic/ObjectView/DetailCard/UserDetailCard';
import { getViewDefintionFromObject } from '../../factories/AttributeDefinitions';
import { useMostProximateCustomer } from '../../../hooks/useMostProximateCustomer';
/** Used as add component override when adding partners */
export const PartnerUserDetailCard = (props) => {
    const viewDefinition = getViewDefinitionForNewObject(props.matchedPrimary) ?? getViewDefintionFromObject(props.matchedPrimary);
    const mpc = useMostProximateCustomer({ item: props.contextUser });
    return (_jsx(UserDetailCard, { ...props, 
        //editMode={ComponentMode.EDIT}
        allowedActions: props.allowedActions, viewDefinition: viewDefinition, isNewObjectIn: true, mostProximateCustomer: mpc, requiredRoles: ['Partner'], showRoleSelection: false, contextUser: props.contextUser, isSmallView: false }));
};
